/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import React from "react";
import { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
} from "@mui/material";
import LayoutMenu from "./LayoutMenu";
import styled from "@emotion/styled";

const Container = styled(Box)`
  display:flex;
  height: 100%;
  flex-direction: column;
  .top { 
    display:flex;
    height: 50px;
    background: #3396f4;
    align-items: center;
    padding-left: 10px;
  }
  .title {
    font-size:20px;
    color:height;
    color:white;
  }  
  .left {     
    width: 240px; 
    overflow-y: auto;
    height: 100%;
    background: #f8f8f8;
  }
  .body { flex:1; display:flex; }  
  .right { padding-left: 15px;
    width: calc(100vw - 240px);
    max-height: 700px;
  }
`;

function Layout(props) {  
  
  const {login} = props
  let cid = login.cid;
  if(cid === undefined) cid='';

   return (
    <Container>
      <Box className="top">
        <Box className="title">대시보드</Box>
      </Box>
      <Box className="body">
        <Box className="left">
          <LayoutMenu login={login} />
        </Box>
        <Box className="right">
        {props.children}
        </Box>
      </Box>
    </Container>
  );
}
export default Layout;


// <Box
    //   css={css`
    //     display: flex;
    //     height: 100vh;
    //   `}
    // >
    //   <Box
    //     css={css`
    //       display: flex;
    //       flex-direction: column;
    //       width: 240px;
    //     `}
    //   >
    //     <Box
    //       css={css`
    //         background: #3396f4;
    //         height: 50px;
    //         display: flex;
    //         align-items: center;
    //       `}
    //     >
    //       <div
    //         css={css`
    //           margin-left: 10px;
    //           color: white;
    //           font-size: 20px;
    //           font-weight: bold;
    //         `}
    //       >
    //         대시보드
    //       </div>
    //     </Box>

    //     <Box
    //       css={css`
    //         flex: 1;
    //         border-right: 1px solid #e0e0e0;

    //       `}
    //     >
    //       <LayoutMenu login={login} />
    //     </Box>

        
    //   </Box>
    //   <Box
    //     css={css`
    //       flex: 1;
    //       display: flex;
    //       flex-direction: column;
    //     `}
    //   >
    //     <Box
    //       css={css`
    //         background: #3396f4;
    //         height: 50px;
    //       `}
    //     >
    //       &nbsp;
    //     </Box>
    //     <Box
    //       css={css`
    //         padding-left: 15px;
    //       `}
    //     >
    //       {props.children}
    //     </Box>
    //   </Box>
    // </Box>
